import { FC } from 'react';
import Page, { PageProps } from '@/components/page';
import RouterTabs from '@/components/router-tabs';
import { TabPanel } from '@/components/router-tabs/helpers';
import ProfileForm from './profile-form';
import IdentForm from './ident-form';

const panels: TabPanel[] = [
  { label: 'Profile', path: 'profile', component: <ProfileForm /> },
  { label: 'Identity', path: 'identity', component: <IdentForm /> },
];

const PartnerPage: FC<PageProps> = () => {
  return (
    <Page title="Partner Settings">
      <RouterTabs panels={panels} />
    </Page>
  );
};

export default PartnerPage;
